import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-footer-type03',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink],
  templateUrl: './footer-type03.component.html',
  styleUrl: './footer-type03.component.scss'
})
export class FooterType03Component implements OnInit {

  public view: any = {}

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef){

    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);

      this._tfmService.filterAndSend(this.view.site._links, "site-images").subscribe(res => {
        this.view.site.images = res.content;

        this.view.site.images.forEach(img => {
          var imgUrl = this._tfmService.getLink(img._links, "view");
          if (imgUrl)
            img.url = this._tfmService.getLink(img._links, "view").href;
        });

        this.view.bannerUrl = this.view.site.images.filter(x=>x.isFeatured && x.isActive).length > 0 ? this.view.site.images.filter(x=>x.isFeatured && x.isActive)[0] : null;
        if (this.view.bannerUrl) {
          this.view.bannerImageClass = "bg-[url('" + this.view.bannerUrl.url + "')]";
          this._cd.detectChanges();
        }

        // this._tfmService.log(this.view);
      });
      // this._tfmService.log(res);
    });
    
    this._tfmService.getDestinations().then(res => {
      this.view.destinations = res;
      // this._tfmService.log(res);
    });

    this._tfmService.getPages().then((res:any) => {
      this.view.pages = res.content.filter(x => !(x.section === 'about' || x.section === 'contact' || x.section === 'travel'));
      // this.view.pages = res;
      this._tfmService.log(res);
    });
    
    this._tfmService.getSiteLayoutOptions().subscribe(res => {
      this.view.layoutOptions = res;
      // this._tfmService.log(res);
    })
  }

  get currentYear(): number {
    return new Date().getFullYear();
  };

  ngOnInit(): void {
  }
}
